import { useState, useEffect } from 'react'
import { useRouter } from 'next/router'
import { connect } from 'react-redux'
import axios from 'axios'
import { FacebookShareButton, LineShareButton, TwitterShareButton} from "react-share";
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Pagination, Navigation } from 'swiper/core';

import App from '../../components/app'
import MayaBgPage from '../../components/MayaBgPage'

import { getImageUrlApi, getUploadImageBase64, getWysiwygUploadImage } from '../../helpers/utils'

import style from '../../styles/pages/promotion.module.scss';

SwiperCore.use([Pagination,Navigation]);

const HighlightDetail = ({ setting, highlightContent }) => {
  const router = useRouter()
  
  const [highlight, setHighlight] = useState(highlightContent);
  const [contentComplete, setContentComplete] = useState(false);
  const [locale, setLocale] = useState(router.locale);

  useEffect(() => {
    fetchHighlight();
  }, [router])

  const fetchHighlight = async () => {
    await setContentComplete(false);

    if(router.locale != locale) {
      setLocale(router.locale)
    }
    
    const res = await axios.get(`${process.env.appUrl}/api/highlight/${router.locale}/${encodeURI(router.query.slug)}`)
    const highlightContentRes = (res.data) ? res.data : null
    
    if(!highlightContentRes.detail) {
      await router.push('/', '/', { locale: router.locale });
    }
    
    if(highlightContentRes.detail && highlightContentRes.detail.gallery) {
      const galleryImages = highlightContentRes.detail.gallery.split(',');
      for (const i in galleryImages) {
        galleryImages[i] = await getUploadImageBase64(`${process.env.appUrl}`, galleryImages[i])
      }
      
      highlightContentRes.detail.gallery = galleryImages;
    }

    highlightContentRes.detail.detail = await getWysiwygUploadImage(`${process.env.appUrl}`, highlightContentRes.detail.detail)
    
    await setHighlight(highlightContentRes)
    await setContentComplete(true);
  }

  return (
    <App setting={setting}>
      <MayaBgPage>
        <div className={`${style.promotion_page} page-content`}>
          
          <div className="container">

            <section className={`${style.promotion_detail_content}`}>
              
              <div className="content-type-block text-center gray">
                <span className="star"><img src="/images/share/icon-content-type-star.svg" alt="content highlight" /></span>
                <span className="title button-1">Highlight</span>
                <span className="star"><img src="/images/share/icon-content-type-star.svg" alt="content highlight" /></span>
              </div>

              <div className={`${style.promotion_page_title_container} content-title-container justified-content-center`}>
                <h2 className={`${style.promotion_page_detail_title} title title-gold text-center`}>{ highlight.detail.name }</h2>
              </div>

              <article className="content-wrapper position-relative">
  
                <nav className="share-content-container">
                  <FacebookShareButton url={`${process.env.appUrl}/${router.locale}${router.asPath}`}><span className="share-button-icon img-block"><img src="/images/share/icon-white-fb-2.svg" alt="Share Facebook" className="full-w" /></span></FacebookShareButton>
                  <TwitterShareButton url={`${process.env.appUrl}/${router.locale}${router.asPath}`}><span className="share-button-icon img-block"><img src="/images/share/icon-white-tw-2.svg" alt="Share Twitter" className="full-w" /></span></TwitterShareButton>
                  <LineShareButton url={`${process.env.appUrl}/${router.locale}${router.asPath}`}><span className="share-button-icon img-block"><img src="/images/share/icon-white-line-2.svg" alt="Share Line" className="full-w" /></span></LineShareButton>
                </nav>


                { (contentComplete && highlight.detail && highlight.detail.gallery) && 
                <div className={`${style.promotion_gallery}`}>
                  { highlight.detail.gallery.length > 0 &&
                    <Swiper 
                      autoHeight={true}
                      spaceBetween={0} 
                      slidesPerView={1} 
                      loop={(highlight.detail.gallery.length > 1) ? true : false} 
                      pagination={{ "clickable": (highlight.detail.gallery.length > 1) ? true : false }} 
                      navigation={(highlight.detail.gallery.length > 1) ? true : false}
                    >
                    {
                      highlight.detail.gallery.map((item, index) => {
                        return <SwiperSlide key={`detail-slide-${index}`}>
                          <div className="img-responsive">
                            <img src={item} className="full-w" alt="Promotion top banner" />
                          </div>
                        </SwiperSlide>
                      })
                    }
                    </Swiper>
                  }
                </div>
                }

                <div className={`${style.promotion_content} content-wysiwyg`} dangerouslySetInnerHTML={{ __html: highlight.detail.detail }}></div>

              </article>

            </section>
            
          </div>

        </div>
      </MayaBgPage>
    </App>
  );
}

export async function getServerSideProps({ res, query, locale }) {
  const apiSettingRes = await axios.get(`${process.env.api}/site-setting/${locale}`)
  const setting = (apiSettingRes) ? apiSettingRes.data : null;

  const apiRes = await axios.get(`${process.env.api}/highlight/${locale}/${encodeURI(query.slug)}`)
  const highlightContent = (apiRes.data) ? apiRes.data : []

  if(!highlightContent.detail) {
      return {
        redirect: {
          permanent: false,
          destination: "/",
        },
        props:{},
      }
  }

  setting.soc_title = highlightContent.detail.soc_title
  setting.soc_description = highlightContent.detail.soc_description
  setting.favicon = await getImageUrlApi(`${process.env.appUrl}`, setting.favicon)
  setting.logo = await getImageUrlApi(`${process.env.appUrl}`, setting.logo)
  setting.soc_image = (highlightContent.detail.soc_image) ? await getImageUrlApi(`${process.env.appUrl}`, highlightContent.detail.soc_image) : await getImageUrlApi(`${process.env.appUrl}`, setting.soc_image)
  setting.site_keyword = `${setting.site_keyword}, ${highlightContent.detail.tags}`


  highlightContent.detail.gallery = (highlightContent.detail && highlightContent.detail.gallery) ? highlightContent.detail.gallery.split(',') : [];

  return { props: { setting, highlightContent } }
}

const mapStateToProps = state => {
  return {}
}

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(HighlightDetail)
